import api from './api';

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: 'admin' | 'therapist';
  user_type: 'doctor' | 'case_manager' | 'nurse' | 'admin' | null;
  tenant_id: number | null;
  phone: string | null;
  license_number: string | null;
  yoman_id: string | null;
  sub_clinic: string | null;
  privilege_id: number | null;
  timezone: string;
  data_access: 'PROD' | 'TEST' | 'ALL';
  is_active: boolean;
  is_2fa_enabled: boolean;
  signature_s3_key: string | null;
  meeting_type_ids: number[];
  created_at: string;
  updated_at: string;
}

export interface UserCreate {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: 'admin' | 'therapist';
  tenant_id?: number;
  phone?: string;
  license_number?: string;
  yoman_id?: string;
  sub_clinic?: string;
  timezone?: string;
  data_access?: 'PROD' | 'TEST' | 'ALL';
  meeting_type_ids?: number[];
}

export interface UserUpdate {
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: 'admin' | 'therapist';
  user_type?: 'doctor' | 'case_manager' | 'nurse' | 'admin';
  tenant_id?: number;
  phone?: string;
  license_number?: string;
  yoman_id?: string;
  sub_clinic?: string;
  timezone?: string;
  data_access?: 'PROD' | 'TEST' | 'ALL';
  is_active?: boolean;
  privilege_id?: number;
  meeting_type_ids?: number[];
}

export const userService = {
  async getUsers(tenantId?: number): Promise<User[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/users/${params}`);
    return response.data;
  },

  async getUser(userId: number): Promise<User> {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  async createUser(userData: UserCreate): Promise<User> {
    const response = await api.post('/users/', userData);
    return response.data;
  },

  async updateUser(userId: number, userData: UserUpdate): Promise<User> {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  async deleteUser(userId: number): Promise<void> {
    await api.delete(`/users/${userId}`);
  },

  async uploadSignature(userId: number, file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    await api.post(`/users/${userId}/signature`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  async getSignatureUrl(userId: number): Promise<string> {
    const response = await api.get(`/users/${userId}/signature`, {
      responseType: 'blob',
    });
    return window.URL.createObjectURL(response.data);
  },

  async deleteSignature(userId: number): Promise<void> {
    await api.delete(`/users/${userId}/signature`);
  },
};